import {useEffect,useState} from 'react'
import {Box,Typography,Button, CircularProgress, IconButton, TextField, InputAdornment, MenuItem, FormControl, InputLabel, Select, Divider} from '@mui/material'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Snackbar from '@mui/material/Snackbar'
import { useNavigate,Navigate } from 'react-router-dom';
import get_results from "../Redux/reducers/get_results"
import get_tests from "../Redux/reducers/get_tests"
import AssessmentDialog from '../Components/AssessmentDialog';
import ResultDialog from '../Components/ResultDialog';
import UserInput from '../Components/UserInput';
import { BarChart, BarPlot } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import { Alarm,  ArrowDropDownOutlined, ArrowForward,  Book, CalendarTodayOutlined, CopyAllRounded, FileOpen, FileOpenTwoTone, Folder, Group, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import check_test from '../Redux/reducers/check_test';
import { add_test } from '../Redux/testSlice';
import { add_tests } from '../Redux/testsSlice';
import ResultDetailDialog from '../Components/ResultDetailDialog';
import BoxData from '../Components/BoxData';
import { PieChart } from '@mui/x-charts';
import get_stat from '../Redux/reducers/get_stat';
import ResultAssDetailDialog from '../Components/ResultAssDetailDialog';


const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black"
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1)
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(1),
	background:theme.palette.mode === 'dark'? 'black' : 'white'
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  background:"#100f0f",
  maxHeight:250,
  minHeight:250,
  justifyContent:"center",
  alignItems:"center"
}),

);

const MaxText = ({navigate,dispatch,tst,text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button onClick={(e)=>{
	  e?.preventDefault()
	  dispatch(add_test(tst))
	  localStorage.setItem("iTest_test",JSON.stringify({
		  id:tst?.id,
		  name:tst?.name,
		  description:tst?.description,
		  time:tst?.time,
		  start_moment:tst?.start_moment,
		  start_date:tst?.start_date,
		  questions:tst?.questions,
		  language:tst?.language,
		  describe:tst?.describe,
		  specialty:tst?.specialty,
		  isRealTime:tst?.isRealTime,
		  owner:tst?.owner,
		  isTest:tst?.isTest,
		  testQuestions:tst?.testQuestions || [],
		  field:tst?.field,
		  level:tst?.level
		}))
	 if(tst?.isTest){
		navigate("/testInfo")
	 }else{
		navigate("/assessmentInfo")
	 }
	}}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
  }

const ResultText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button style={{fontWeight:500,fontSize:11,color:'white',marginLeft:5,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
}
	
  const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,marginLeft:10}}> {displayText} </Typography>
  }

const Home = ()=>{

	const [code,setCode] = useState("")
	const [message,setMessage] = useState("")
	const [checking,setChecking] = useState(false)
	const user = useSelector(state => state?.auth.user);
	const [showResModal, setShowResModal] = useState(false);
	const [showAssModal, setShowAssModal] = useState(false);
	const [showResultModal, setShowResultModal] = useState(false);
	const [showAssResultModal, setShowAssResultModal] = useState(false);
	// const socket = io(process.env.REACT_APP_SOCKET_URL);
	const [result, setResult] = useState('');
	const [expanded, setExpanded] = useState(true);
	const [expandedGraph, setExpandedGraph] = useState(false);
	const [expandedApi, setExpandedApi] = useState(false);
	const [fetching, setFetching] = useState(false);
	const [statData, setStatData] = useState({});
	const [title, setTitle] = useState("");
	const [score, setScore] = useState(0);
	const [testArray, setTestArray] = useState([]);
	const [results, setResults] = useState([]);
	const [quota,setQuota] = useState("");
	const [filter,setFilter] = useState("");
	const [open, setOpen] = useState(false);
	const options = ['Statistics', 'Graphic'];
    const [value, setValue] = useState(options[0]);
	const navigate = useNavigate()
	const dispatch = useDispatch()

const theme = useTheme() 

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

const handleChangeGraph = () => (event, newExpanded) => {
	setExpandedGraph(newExpanded ? true : false);
};

const handleChangeApi = () => (event, newExpanded) => {
	setExpandedApi(newExpanded ? true : false);
};

async function handleTest (){
	try{
		if (code !== null) {
			const data = {
				code:code,
				email:user?.email,
				token:user?.accessToken
			}

			check_test(data,setChecking,dispatch,add_test,setOpen,setMessage,navigate)

		} else {
			setMessage("please,give the Test code")
			setOpen(true)
		}
	}catch(err){
		console.log(err)
	}
}

async function handleGetStat (){
	try{
		if (user?.auth && user?.email) {
			
			const data = {email:user?.email}

			get_stat(data,setFetching,user?.accessToken,setStatData)

		}
	}catch(err){
		console.log(err)
	}
}


if (!user?.auth) {
	return <Navigate to="/login" />;
}

useEffect(() => {
	handleGetStat()
	get_results(user?.email,setResults,user?.accessToken)
	get_tests(user?.email,setTestArray,add_tests,dispatch,user?.accessToken)
}, []);

return(
	<Box sx={{width:"100%",height:"100%",justifyContent:{xs:"flex-start",md:"center"},alignItems:{xs:"flex-start",md:"center"}}}>
		<Header>
			<Breadcrumbs aria-label="breadcrumb">
				<Typography sx={{fontSize:12,color:"gray"}}>/ Dashboard </Typography>
			</Breadcrumbs>			
		</Header>
		<Snackbar 
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}} 
			message={message} 
			onClose={()=>{setOpen(false)}}
			open={open} 
			autoHideDuration={2000}
		/>
		<Box sx={{ml:{md:1},width:{md:"40%",xs:"25%"}}} display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" >
			<Button onClick={(e)=>{
				e?.preventDefault()
				navigate("/createTrain")
			}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10}} variant="contained">
				Training
			</Button> 
			<Button onClick={(e)=>{
				e?.preventDefault()
				navigate("/template")
			}} sx={{background:"gold",display:{xs:"none",md:"inline-block"},color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10}} variant="contained">
				templates
			</Button> 
			<Button onClick={(e)=>{
				e?.preventDefault()
				navigate("/jobs")
			}} sx={{background:"gold",display:{xs:"none",md:"inline-block"},color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10}} variant="contained">
				offers
			</Button> 
		</Box>
		<Box mb={1}  mt={1}>
		<Box display="flex" flexWrap="wrap" justifyContent="space-between" p={1} >
				<Box   p={1} sx={{width:"100%",background:"#000000",display:{xs:"none",md:"block"}}}>
					<Accordion sx={{width:"100%",marginLeft:1}} expanded={expandedGraph} onChange={handleChangeGraph(true)}>
						<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
							<Box justifyContent="flex-start" alignItems="flex-start" mt={1} width="100%">
								<Box flexDirection="row" display="flex" justifyContent="flex-start" alignItems="center" width="20%" mb={1}>
									<Typography  style={{fontSize:13,fontFamily:"dinofans",color:"#fff",marginRight:10}}>
										Plan 
									</Typography>
									<IconButton  sx={{backgroundColor:"#fff",borderRadius:1}}>
										<Typography  style={{fontSize:10,fontFamily:"dinofans",color:"#000"}}>
											Premium
										</Typography>
									</IconButton>
								</Box>
								<Typography  style={{fontSize:14,fontFamily:"dinofans",color:"gray"}}>
									DASHBOARD
								</Typography>
							</Box>
						</AccordionSummary>
						<AccordionDetails sx={{justifyContent:{md:"space-evenly",xs:"center"},alignItems:{md:"flex-start",xs:"center"},flexDirection:"row",display:"flex",flexWrap:"wrap"}}>
							{/* <Box sx={{width:"100%",textAlign:"left",ml:2}}>
								<SelectButton value={value} onChange={(e) => setValue(e.value)} options={options} style={{}}/>
							</Box> */}
							<BoxData title="AI Tests">
								<IconButton>
									{
										fetching ? 
											<CircularProgress size={15} sx={{color:"#fff"}}/>
										:
											<Typography sx={{mr:1,color:"#fff",fontSize:14,ml:1}}>
												{statData?.tests ? statData?.tests  : 0}
											</Typography>
									}
									<Folder fontSize='small' sx={{color:"#fff"}}/>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/myTests")
								}}>
									<ArrowForward sx={{color:"#fff"}}/>
								</IconButton>
							</BoxData>
							<BoxData title="Template Tests">
								<IconButton>
									{
										fetching ? 
											<CircularProgress size={15} sx={{color:"#fff"}}/>
										:
											<Typography sx={{mr:1,color:"#fff",fontSize:14,ml:1}}>
												{statData?.assessments ? statData?.assessments  : 0}
											</Typography>
									}
									<Folder fontSize='small' sx={{color:"#fff"}}/>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/myTests")
								}}>
									<ArrowForward sx={{color:"#fff"}}/>
								</IconButton>
							</BoxData>
							<BoxData title="Templates">
								<IconButton>
									{
										fetching ? 
											<CircularProgress size={15} sx={{color:"#fff"}}/>
										:
											<Typography sx={{mr:1,color:"#fff",fontSize:14,ml:1}}>
												{statData?.templates ? statData?.templates  : 0}
											</Typography>
									}
									<FileOpen fontSize='small' sx={{color:"#fff"}}/>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/template")
								}}>
									<ArrowForward sx={{color:"#fff"}}/>
								</IconButton>
							</BoxData>
							<BoxData title="Published offers ">
								<IconButton>
									{
										fetching ? 
											<CircularProgress size={15} sx={{color:"#fff"}}/>
										:
											<Typography sx={{mr:1,color:"#fff",fontSize:14,ml:1}}>
												{statData?.jobs ? statData?.jobs  : 0}
											</Typography>
									}
									<Book fontSize='small' sx={{color:"#fff"}}/>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/jobs")
								}}>
									<ArrowForward sx={{color:"#fff"}}/>
								</IconButton>
							</BoxData>
							{/* <Box width="40%">
								<LineChart
									xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
									series={[
										{
										data: [2, 5.5, 2, 8.5, 1.5, 5],
										area: true,
										},
									]}
									width={330}
									height={300}
								/>
							</Box>
							<Box width="40%">
								<PieChart
									series={[
										{
										data: [
											{ id: 0, value: 10, label: 'Tests' },
											{ id: 1, value: 15, label: 'Templates' },
											{ id: 2, value: 20, label: 'Offers' },
										],
										},
									]}
									width={300}
									height={400}
										
								/>
							</Box> */}
						</AccordionDetails>
					</Accordion>
				</Box>
			</Box>
			<Box display="flex" sx={{flexDirection:{xs:"column",md:"row"}}} justifyContent="space-between" alignItems="flex-start">
				<Accordion sx={{width:{xs:"100%",md:"50%"},marginLeft:{xs:0,md:2}}} expanded={expanded} onChange={handleChange(true)}>
					<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
						<Box>
							<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
								Take an assessment
							</Typography>
							<Typography mt={2} ml={2} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
								Assessment Code
							</Typography>
						</Box>
					</AccordionSummary>
					<AccordionDetails sx={{justifyContent:"center",alignItems:"center",ml:{xs:0,md:2}}}>
						<Box sx={{width:"100%"}}>
							<UserInput
								label="Code *"
								isPass={false}
								input={code}
								setInput={setCode}
							>
								<NumbersTwoTone fontSize='small'/>
							</UserInput>
							<Button disabled={checking ? true : false} onClick={()=>{
								handleTest()
							}} sx={{color:"gold",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12}} variant="outlined">
								{
									checking ? <CircularProgress size={20} style={{color:"gold"}}/> : "ACCESS"
								}
							</Button>
						</Box>
					</AccordionDetails>
				</Accordion>
				<ContainerBox sx={{width:{xs:"100%",md:"50%"},minHeight:230,marginLeft:{xs:1,md:2},background:"#000000",borderRadius:2,padding:1}}>
					<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography m={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
							my assessments
						</Typography>
						<Button onClick={(e)=>{
							e?.preventDefault()
							navigate("/myTests")
						}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
							View all
						</Button> 
					</Box>
					<Box justifyContent="center" alignItems="center" width="100%">
						{
							testArray?.length == 0 && (
								<Box textAlign="center" width="100%"p={1}>
									<Box textAlign="center" >
										<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
									</Box>
									<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5 }}>
										Assessments could not be found
									</Typography>
									<Box textAlign="center" width="100%" mt={1}>
		                                <Button onClick={(e)=>{
		                                    e?.preventDefault()
		                                    navigate("/createTest")
		                                  }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
		                                    Create now
		                                </Button>
		                            </Box>  
								</Box>
							)
							} 
							{
							testArray?.map((item,index)=>{
								return(
								<Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"100%",justifyContent:"center",alignContent:"center"}}>
									<MaxText navigate={navigate} dispatch={dispatch} tst={item} text={`# ${index+1}  ${item?.name}`} limit={30}/>
									<Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center" width="90%" mt={1}>
										<Box>
											<QuizOutlined fontSize='small'/>
											<Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
												{item?.level}
											</Typography>
										</Box>
										<Box>
											<CalendarTodayOutlined fontSize='small'/>
											<Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
												{item?.start_date}
											</Typography>
										</Box>
										<Box>
											<Alarm fontSize='small'/>
											<Typography sx={{fontSize:10,fontWeight:400,color:"gray"}}>
												{item?.start_moment}
											</Typography>
										</Box>
									</Box>
									<DescriptionText text={item?.description} limit={55}/>
								</Box>
								)
							})
                        }		
					</Box>
				</ContainerBox>
			</Box>
			<Box display="flex" flexWrap="wrap" justifyContent="space-between" p={1} >
				<ContainerBox sx={{width:{xs:"100%",md:"50%"},marginLeft:{xs:1},background:"#000000",borderRadius:2,padding:1,borderColor:"gray",borderWidth:2}}>
					<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography m={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
							my Results
						</Typography>
						<Button onClick={()=>{
							setShowResModal(true)
						}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
							View all
						</Button> 
					</Box>
					<Box textAlign="center" width="100%">
					{
                        results?.length == 0 && (
							<Box textAlign="center"  p={1}>
								<Box justifyContent="center" alignItems="center" >
									<img width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
								</Box>
                            	<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5,marginLeft:5}}>
                               		Results could not be found
                              </Typography> 
                          </Box>
                        )
                      } 
                      {
                        results?.map((item,index)=>{
                          return(
                            <Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"95%",justifyContent:"center",alignContent:"center"}}>
                                <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="flex-start">
									<ResultText text={`# ${index+1}  ${item?.title}`} limit={25}/>
									<Typography sx={{fontSize:11}} pb={1} pt={1} >
										{item?.test_date}
									</Typography>									
								</Box>
								<Box display="flex" flexDirection="row" justifyContent={item?.conclusion === "pending" ? "flex-start" :  "space-between"} alignItems="center">
									<Typography width={45} p={1} ml={3} borderRadius={2} sx={{fontSize:12,color:(item?.conclusion !== "pending" ? "white" : "black"),background:(item?.conclusion === "pending" ? "gold" : item?.conclusion === "fail" ? "red" : "green")}}>
										{item?.score} %
									</Typography>
									{
									((item?.conclusion === "fail" || item?.conclusion === "accept") && !item?.isDisqualified) && (
										<Button onClick={()=>{
											setResult(item?.data)
											setScore(item?.score)
											if(item?.isTest){
												setShowResultModal(true)
											}else{
												setShowAssResultModal(true)
											}
										}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
											Result
										</Button>                                    
									)
									}
									{
										item?.isDisqualified && (
                                            <Typography  p={1} ml={1} borderRadius={2} sx={{fontSize:12,color:"white",background:"red"}}>
												You have been Disqualified
                                            </Typography>
                                        )
									}								
								</Box>
								{
									!item?.isDisqualified && (
										<DescriptionText text={item?.description} limit={120}/> 
									)
								}
                            </Box>
                          )
                        })
                      } 
					</Box>
				</ContainerBox>
			</Box>
		</Box>
		<ResultDetailDialog visible={showResultModal} setVisible={setShowResultModal} content={result}/>
		<AssessmentDialog visible={showAssModal} setVisible={setShowAssModal} />
		<ResultDialog visible={showResModal} setVisible={setShowResModal} />
		<ResultAssDetailDialog score={score} visible={showAssResultModal} setVisible={setShowAssResultModal} content={result}/>
	</Box>
	)
}

export default Home